import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    name: 'OverlayFps',
    props: {
        currentFps: { type: Number, default: 0 },
    },
});
